<app-service-settings-common
    [settingsKey]="SERVICE_SETTINGS_CONTINUOUS_RECORD_TYPE_KEY"
    [title]="'workData.continuousRecord.labelMulti'"
></app-service-settings-common>
